export const BuildInfo = {timestamp:1784150467000}
